module.exports = __webpack_public_path__ + "img/about_7.1ba61da2.jpg";